import React from "react";

import styled from "@emotion/styled";

import { Shadow } from "../../../../utils/BreakpointHelpers";
import LinkComponent from "../../LinkComponent";

const CardContainer = styled.div`
    ${({ theme }) => theme.paddings.containerOuter.left}
    ${({ theme }) => theme.paddings.containerOuter.right}

    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    color: ${({ theme }) => theme.colors.blue.toString()};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.grey.toString()};
    justify-content: space-between;
    ${({ theme }) => theme.breakpoints.from.small.css`
       ${Shadow};

       border-color: none;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
       flex-direction: row;
       padding: 20px;
    `};
`;

const Left = styled.div`
    font-size: 1.5rem;
    align-self: flex-start;
    font-weight: 600;
    ${({ theme }) => theme.breakpoints.from.medium.css`
       width: 20%;
    `}
`;

const Middle = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 10px;
`;

const DocumentsCard = ({ document }) => {
    return (
        <CardContainer>
            <Left>Speisekarte</Left>
            <Middle>
                {!Array.isArray(document) || document.length === 1 ? (
                    <LinkComponent
                        moveIcon={false}
                        icon="download"
                        link={{
                            text: "Downloaden",
                            href: Array.isArray(document)
                                ? document[0].url
                                : document,
                        }}
                    />
                ) : (
                    <>
                        {document.map((document, index) => (
                            <LinkComponent
                                key={index}
                                moveIcon={false}
                                icon="download"
                                link={{
                                    text: document.filename,
                                    href: document.url,
                                }}
                            />
                        ))}
                    </>
                )}
            </Middle>
        </CardContainer>
    );
};

export default DocumentsCard;
